import { BULK_DELETE, REFERRAL_COORDINATOR } from "constants/endpoints";
import { result } from "lodash";
import { deleteApi, get, post, put, patch } from "services/network";
import { toast } from "react-toastify";
import CustomToast from "components/common/custom-toast";
import { alertTypes } from "constants/common";
import { SEND_CONFIRMATION } from "constants/endpoints";

export const getReferralCoordinators = async (obj) => {
  const params = {
    page: obj?.page ? obj.page : 1,
    perPage: obj?.perPage ? obj.perPage : 10,
    search: obj?.search ? obj.search : "",
    status: obj?.status,
    filter: obj?.filter || "",
  };
  try {
    const result = await get(
      `${REFERRAL_COORDINATOR}?page=${params.page}&per=${
        params.perPage
      }&query=${params.search}${
        params.status ? "&filter[status]=active" : ""
      }&filter[user_type]=${params.filter}`,
      true
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};
export const createReferralCoordinators = async (
  data,
  setErrors = () => {}
) => {
  try {
    const result = await post(`${REFERRAL_COORDINATOR}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Referral Coordinator created successfully"
      />
    );
    return result;
  } catch (error) {
    if (error?.response?.data) {
      setErrors(error?.response?.data?.errors);
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={error?.response?.data?.errors?.email}
        />
      );
    } else {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={error?.response?.statusText}
        />
      );
    }
    console.log(error);
  }
};
export const updateReferralCoordinators = async (
  data,
  id,
  setErrors = () => {}
) => {
  try {
    const result = await put(`${REFERRAL_COORDINATOR}/${id}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Referral Coordinator updated successfully"
      />
    );
    return result;
  } catch (error) {
    if (error?.response?.data) {
      setErrors(error?.response?.data.errors);
    }
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />
    );
    console.log(error);
  }
};
export const updateReferralCoordinatorPassword = async (data, id) => {
  try {
    const result = await patch(
      `${REFERRAL_COORDINATOR}/${id}/password_update`,
      data,
      true
    );
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Referral Coordinator's password updated successfully"
      />
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />
    );
    console.log(error);
  }
};
export const deleteReferralCoordinators = async (id) => {
  try {
    const result = await deleteApi(`${REFERRAL_COORDINATOR}/${id}`, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Referral Coordinator deleted successfully"
      />
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />
    );
    console.log(result);
  }
};
export const deleteBulkReferralCoordinators = async (data) => {
  try {
    const result = await put(
      `${REFERRAL_COORDINATOR}/${BULK_DELETE}`,
      data,
      true
    );
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Referral Coordinator deleted successfully"
      />
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />
    );
    console.log(result);
  }
};
export const sendReferralCoordinatorConfirmationEmail = async (id) => {
  try {
    const result = await post(
      `${REFERRAL_COORDINATOR}/${id}/${SEND_CONFIRMATION}`,
      null,
      true
    );
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Referral Coordinator confirmation sent successfully"
      />
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />
    );
    console.log(result);
  }
};
